export class Compartir {
    /**Correo */
    v1: string = "";
    /**Parametros varios */
    v2: Array<DataV2> = new Array<DataV2>();
    /**Parametro numerico */
    v3: number = 2;
    /**polizaId */
    pid: number = 0;
}

export class DataV2 {
    /**Poliza Id encriptado */
    c1: string = "";
    /**Se agrego por si era necesario */
    c2?: string;
    /**Parametro numerico */
    c3: number = 1;
}